export const AUTH_CONTEXT_ERROR =
  "Authentication context not found. Have your wrapped your components with AuthContext.Consumer?";
